import React from "react";
import Form from "../../components/Widgets/Form";
import RaisedButton from "../../components/Widgets/Button";
import { TextField } from "../../components/Widgets/Input";
import { Link } from "react-router-dom";


function Login() {
  return (
    <div className="gradient">
      <Form heading="Login">
        <TextField type="text" id="username" hint_text="Username or GMail" />
        <TextField type="password" id="pass" hint_text="Password" />

        <div className="form-action-buttons">
            <RaisedButton variant="button-primary" text="Login" />
            <Link className="link-primary" to="/tracemall/signup">Don't have an Account? Sign Up</Link>
        </div>

      </Form>
    </div>
  );
}

export default Login;